import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/store';
import { date2array4export } from '../../utils/dateTime';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown as faExport } from '@fortawesome/free-solid-svg-icons';
import { EventAttributes, createEvents } from 'ics';
import './ExportButton.css';
/**
 * Кнопка экспорта календаря в формат iCalendar (ICS)
 */
const ExportButton = () => {
	const { t, i18n } = useTranslation();
    const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const company = i18n.language === 'en' ? 'company_en' : 'company_ru';
    const position = i18n.language === 'en' ? 'position_en' : 'position_ru';
    const user = useAppSelector(store => store.auth.user);
    const event = useAppSelector(store => store.event);
    const slots = useAppSelector(store => store.slots);
    const requests = useAppSelector(store => store.requests);
    const attendees = useAppSelector(store => store.attendees);
    const [ show, setShow ] = useState(false);

    // Показываем кнопку только если прошла дата, до которой можно назначать встречи
    useEffect(() => {
        if(!event || !event.request_until) {
            setShow(false);
            return;
        }
        const today = Date.now() + 3 * 60 * 60 * 1000; // +3 часа
        const until = Date.parse(event.request_until);
        if(today >= until) setShow(true);
    }, [ event ]);

    const doExport = async () => {
        if(!user) return;
        const events: EventAttributes[] = [];

        // Фильтруем подтвержденные встречи и перебираем их все
        requests.filter(r => r.status === 'approved').forEach(r => {
            const slot = slots.find(s => s.id === r.slot_id);
            const aid = r.from_id === user?.id ? r.to_id : r.from_id;
            const respondent = attendees.find(a => a.id === aid);
            if(slot && respondent) {
                events.push({
                    start: date2array4export(slot.start),
                    startInputType: 'utc', // необходимо передавать дату встречи в UTC 
                    startOutputType: 'utc', // т.к. люди могут быть в разных часовых поясах
                    duration: { minutes: slot.duration },
                    status: 'CONFIRMED',
                    title: event ? `${event[name]} - ${respondent[name]}` : respondent[name],
                    description: `${respondent[name]}\n${respondent[company]}\n${respondent[position]}`,
                    calName: event ? event[name] : undefined,
                    /*
                    attendees: [{
                        name: user[name],
                        email: user.email ?? 'unknown@unknown.com',
                    },{
                        name: respondent[name],
                        email: respondent.email ?? 'unknown@unknown.com',
                    }]
                    */
                });
            }
        });

        // Создаем календарь и инициируем скачивание файла
        const filename = event?.slug ? `${event.slug}.ics` : 'Meetings.ics';
        const getfile = new Promise((resolve, reject) => {
            createEvents(events, (error, value) => {
                if (error) reject(error);                
                resolve(new File([value], filename, { type: 'plain/text' }));
            });
        });

        getfile.then(
            file => {
                const url = URL.createObjectURL(file as File);
                // trying to assign the file URL to a window could cause cross-site
                // issues so this is a workaround using HTML5
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = filename;
                
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                
                URL.revokeObjectURL(url);        
            },
            error => {
                console.error(error);
            }
        );
    };

    if(!show) return null;

    return <span className='ExportButton' onClick={() => doExport()}>
                <Icon icon={faExport}/>&nbsp;&nbsp;
                <span className='a'>{t('profile.export')}</span>
            </span>
};

export default ExportButton;
